import {
  isValidIpAddress,
  parseIpAddresses,
} from "../../../utils/ipAddress";

export type StaffRegulatorFormValues = {
  email: string;
  given_name: string;
  family_name: string;
  timezone: string;
  whitelisted_ips: string;
};

export const STAFF_REGULATOR_FORM_INITIAL_VALUES: StaffRegulatorFormValues = {
  email: "",
  given_name: "",
  family_name: "",
  timezone: "",
  whitelisted_ips: "",
};

export const getDefaultTimezone = (): string => {
  try {
    // eslint-disable-next-line no-restricted-syntax -- reading the browser IANA tz string, not formatting a date
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
};

export const isWhitelistedIpsInputValid = (value: string): boolean =>
  parseIpAddresses(value).every(isValidIpAddress);

export const toCreateStaffRegulatorPayload = (
  values: StaffRegulatorFormValues,
) => ({
  email: values.email.trim(),
  given_name: values.given_name.trim(),
  family_name: values.family_name.trim(),
  timezone: values.timezone.trim(),
  whitelisted_ips: parseIpAddresses(values.whitelisted_ips),
});
